<svelte:options customElement={{
  tag: 'label-tag',
  shadow: 'none',
  props: {
    text: { reflect: true, type: 'String' },
    variant: { reflect: true, type: 'String' }
  }
}} />

<script>
  /**
   * ラベルパーツ
   * パーツライブラリ準拠の mod-label 構造
   * @prop {string} text - ラベルテキスト
   * @prop {string} variant - バリエーション:
   *   'type1' (_type1 メインカラー背景), 'type2' (_type2 グレー背景),
   *   'type3' (_type3 ボーダー), 'new' (_new 赤背景),
   *   'required' (_required 必須), 'optional' (_optional 任意)
   */
  export let text = '';
  export let variant = 'type1';

  $: className = `mod-label _${variant}`;
</script>

<span class={className}>
  {#if text}
    {text}
  {:else}
    <slot></slot>
  {/if}
</span>
